(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const blocks = document.querySelectorAll('.custom-product-desc');
    if (!blocks.length) return;

    blocks.forEach((block) => {
      const toggle = block.querySelector('[data-expand-toggle]');
      const content = block.querySelector('[data-expandable-content]');
      if (!toggle || !content) return;

      const textSpan = toggle.querySelector('.custom-product-desc__toggle-text');

      const labelMore = toggle.getAttribute('data-label-more');
      const labelLess = toggle.getAttribute('data-label-less');

      const setState = (expanded) => {
        block.dataset.expanded = expanded ? 'true' : 'false';
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (textSpan) {
          textSpan.textContent = expanded ? labelLess : labelMore;
        }
      };

      setState(false);

      toggle.addEventListener('click', () => {
        const isExpanded = block.dataset.expanded === 'true';
        setState(!isExpanded);

        if (document.startViewTransition) {
          document.startViewTransition(() => {
            content.offsetHeight;
          });
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
